import { useParams } from 'react-router';
import {
} from '@mui/material';
import Categories from './Categories';

const DealsSettings = ({showNotification}) => {
  const { tenantId } = useParams();

  return (
    <>
      {/* Deal Config Settings Sections */}
      <Categories showNotification={showNotification} tenantId={tenantId}/>
   </>
  );
};

export default DealsSettings;
